import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle, FileSearch } from 'lucide-react';
import { Card } from './ui/Card';
import { useLanguage } from '../hooks/useLanguage';
export function ProblemReveal() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-116">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#DC2626]/5 rounded-full blur-3xl pointer-events-none" data-id="element-117" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#DC2626]/10 text-[#DC2626] font-bold mb-6" data-id="element-120">
            <AlertTriangle className="w-5 h-5" data-id="element-121" />
            {t('problem_badge')}
          </motion.div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-122">
            {t('problem_h2_before')}{' '}
            <span className="text-[#DC2626]" data-id="element-123">{t('problem_h2_highlight')}</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-124">
            {t('problem_subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-125">
          <Card className="border-l-4 border-l-[#DC2626]" data-id="element-126">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-127">
              <XCircle className="text-[#DC2626]" data-id="element-128" />
              {t('problem_card1_title')}
            </h3>
            <p className="text-gray-400 mb-4" data-id="element-129">
              {t('problem_card1_p1_before')}{' '}
              <span className="text-white font-semibold" data-id="element-130">
                {t('problem_card1_p1_highlight')}
              </span>
            </p>
            <p className="text-gray-400" data-id="element-131">{t('problem_card1_p2')}</p>
          </Card>

          <Card variant="highlight" className="border-l-4 border-l-[#D4A843]" data-id="element-132">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-133">
              <FileSearch className="text-[#D4A843]" data-id="element-134" />
              {t('problem_card2_title')}
            </h3>
            <p className="text-gray-400 mb-4" data-id="element-135">
              {t('problem_card2_p1_before')}{' '}
              <span className="text-[#D4A843] font-bold" data-id="element-136">
                {t('problem_card2_p1_highlight')}
              </span>
              {t('problem_card2_p1_after')}
            </p>
            <p className="text-gray-400" data-id="element-137">{t('problem_card2_p2')}</p>
          </Card>
        </div>
      </div>
    </section>;
}